(function () {
  'use strict';

  var MIN_CENTS = 1000;
  var WARN_CLASS = 'cart-minimum-warning';

  function fmt(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function warnHtml(needed) {
    return '<strong>Minimum Order: ' + fmt(MIN_CENTS) + '</strong> &mdash; Please Add ' +
      fmt(needed) + ' More To Your Cart And Proceed To Checkout.';
  }

  function warnElement(needed) {
    var d = document.createElement('div');
    d.className = WARN_CLASS;
    d.style.cssText = 'padding:12px;margin-bottom:12px;background-color:#fff3cd;border:1px solid #ffeaa7;border-radius:4px;color:#856404;font-size:14px;';
    d.innerHTML = warnHtml(needed);
    return d;
  }

  function applyState(belowMin, isEmpty, needed) {
    var buttons = document.querySelectorAll('button[name="checkout"]');
    buttons.forEach(function (btn) {
      btn.disabled = belowMin || isEmpty;

      var form = btn.closest('form');
      var container = form ? form.parentElement : btn.parentElement;
      if (!container) return;

      var existing = container.querySelector('.' + WARN_CLASS);

      if (belowMin) {
        if (existing) {
          existing.innerHTML = warnHtml(needed);
          existing.style.display = '';
        } else {
          var target = form || btn;
          container.insertBefore(warnElement(needed), target);
        }
      } else if (existing) {
        existing.style.display = 'none';
      }
    });
  }

  function refresh() {
    fetch('/cart.js', {
      headers: { 'Accept': 'application/json' },
      credentials: 'same-origin'
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var isEmpty = cart.item_count === 0;
        var belowMin = !isEmpty && cart.total_price < MIN_CENTS;
        var needed = MIN_CENTS - cart.total_price;
        applyState(belowMin, isEmpty, needed);
      })
      .catch(function () { });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh);
  } else {
    refresh();
  }

  var origFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var promise = origFetch.apply(this, arguments);
    if (/\/cart(\.js|\/(add|update|change|clear))/.test(url)) {
      promise.then(function () { setTimeout(refresh, 200); }, function () { });
    }
    return promise;
  };

  var origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (typeof url === 'string' && /\/cart(\.js|\/(add|update|change|clear))/.test(url)) {
      this.addEventListener('load', function () { setTimeout(refresh, 200); });
    }
    return origOpen.apply(this, arguments);
  };

  window.cartMinOrderRefresh = refresh;
})();
